import React, { useRef } from 'react'
import { Flashcard } from 'interfaces/Flashcard'
import { getCountryLanguageConfig } from 'lib/constants/countryLanguageConfig'
import dynamic from 'next/dynamic'
import { KnowSeoInfo } from 'interfaces/KnowSeoInfo'
import { useRouter } from 'next/router'
import { parseLocale } from 'lib/constants/localization'
import useImpressionTracking from 'lib/hooks/useImpressionTracking'
import { KnowTranscript } from 'interfaces/Know'
import { AnalyticsEventKnowSubjectsSectionImpression } from 'lib/constants/AnalyticsEventType'
import { getReferrerScreen } from 'lib/formatting/url'
import Stack from 'components/elements/Stack'

const SEOKnowunitySubjects = dynamic(() => import('../SEOKnowunitySubjects'))
const SEOKnowunityAdvantages = dynamic(() => import('../SEOKnowunityAdvantages'))

interface Props {
    transcript?: KnowTranscript | null
    flashcards?: Flashcard[] | null
    knowSeoInfo: KnowSeoInfo
    isDarkTheme?: boolean
    showGradientKnowPageDesign?: boolean
}

const KnowSEOBelowFoldSection = ({ knowSeoInfo, transcript, flashcards, isDarkTheme }: Props) => {
    const router = useRouter()
    const parsedLocale = parseLocale(router.locale)
    const countryLanguageConfig = getCountryLanguageConfig(router.locale)
    const isLaunched = !!countryLanguageConfig?.isLaunched
    const referrerScreen = getReferrerScreen(router)
    const { know } = knowSeoInfo

    const knowSubjectsRef = useRef<HTMLDivElement>(null)
    useImpressionTracking(knowSubjectsRef, AnalyticsEventKnowSubjectsSectionImpression, { referrerScreen, know })

    return (
        <Stack gutter={0}>
            <SEOKnowunitySubjects objectRef={knowSubjectsRef} parsedLocale={parsedLocale} isDarkTheme={isDarkTheme} />
            <SEOKnowunityAdvantages isLaunched={isLaunched} know={know} isDarkTheme={isDarkTheme} />
        </Stack>
    )
}

export default KnowSEOBelowFoldSection
